import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { IShiftScheduleRepository } from "./IShiftScheduleRepository";
import { ShiftSchedule } from "src/app/models/HR/ShiftSchedule/shiftSchedule";

@Injectable()
export class ShiftScheduleRepository extends GenericRepository<any> implements IShiftScheduleRepository {
 
  url: string = environment.urlAddress;
  constructor(protected _http: HttpClient) {
      super(_http, 'api/ShiftSchedule', environment.urlAddress);
    }   
 
     NavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
         return this.Get('NavRec/' + navType + '/' + currentIndex);
     }
 
     GetRec(code: number): Observable<ResponseModel> {
         return this.Get('GetRec/' + code);
     }
 
     SelectAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<ResponseModel> {
         filterText = filterText.split('/').join('~');
         if (filterText == "") {
             filterText = "|";
         }
 
         return this.Get('SelectAll/' + currentPage + '/' + recordsPerPage + '/' + filterText);
     } 
 
     SaveRec(item: ShiftSchedule): Observable<ResponseModel> {
         return this.PostData('/SaveRec/', item);
     }
 
     DeleteRec(code: number): Observable<ResponseModel> {
         return this.Get('DeleteRec/' + code);
     }
 
}